// Mozi Wash Scent Grid: the cards are a grid from 750px up and a looping,
// centred Swiper carousel below it (drag, swipe and dots), the same setup as
// the Scent Good Slider. The carousel is built and torn down as the viewport
// crosses the breakpoint, and rebuilt when the theme editor reloads it.
(function () {
  var mobile = window.matchMedia('(max-width: 749px)');

  function sync(section) {
    var el = section.querySelector('[data-mw-scents-slider]');
    if (!el || typeof Swiper === 'undefined') return;

    if (!mobile.matches) {
      if (el.swiper) el.swiper.destroy(true, true);
      return;
    }
    if (el.swiper) return;

    new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      centeredSlides: true,
      loop: el.querySelectorAll('.swiper-slide').length > 2,
      grabCursor: true,
      pagination: {
        el: section.querySelector('[data-mw-scents-dots]'),
        clickable: true
      }
    });
  }

  function syncAll() {
    document.querySelectorAll('[data-mw-scents]').forEach(sync);
  }

  // The theme loads Swiper with a deferred tag after the page content, so it
  // isn't defined yet when this (also deferred) script runs; every deferred
  // script has run by DOMContentLoaded. sync() is idempotent.
  syncAll();
  document.addEventListener('DOMContentLoaded', syncAll);
  window.addEventListener('load', syncAll);
  mobile.addEventListener('change', syncAll);

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-mw-scents]');
    if (section) sync(section);
  });
})();
